import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {MenuService} from '../../../services/menu.service';
import {ModuleService} from '../../../services/module.service';
import {PermissionService} from '../../../services/permission.service';

@Component({
  selector: 'app-single-add',
  templateUrl: './single-add.component.html',
  styleUrls: ['./single-add.component.scss']
})
export class SingleAddComponent implements OnInit{

  menuForm: FormGroup;
  modules: any[] = [];
  permissions: any[] = [];

  loading = 'Loading...';

  public types: any[] = [
    {id: 1, name: 'link', title: 'single'}
  ];
  moduleSelected: number | undefined;
  categorySelected: number | string | undefined;

  saving = false;

  isSubmitted = false;
  val: any | null;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private menuService: MenuService,
              private moduleService: ModuleService,
              private permissionService: PermissionService,
              private translate: TranslateService,
              private toastr: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router
  ) {
    console.log(this.types[0]["title"]);
    this.menuForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      path: [''],
      icon: [''],
      type: ['', [Validators.required]],
      module: ['', [Validators.required]],
      position: null,
      permission: null,
      title: this.types[0]["title"],
      isEnable: '',
    });

  }

  ngOnInit(): void {
    this.menuForm.get('isEnable')?.setValue('1');
    this.findAllModule();
    this.findAllPermissions();

    this.categorySelected = 'link'
  }

  get fc(): any {
    return this.menuForm.controls;
  }

  changeVal(value: any): void{
    this.val = value;
    console.log(this.val);
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    if (this.menuForm.valid){
      this.saving = true;
      this.menuForm.get('isEnable')?.setValue(this.menuForm.get('isEnable')?.value === '1');
      this.menuService.postSingle(this.menuForm.value).subscribe({
          next: (val: any) => {
            this.toastr.success('Menu create with success !', 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            console.log(err);
            const errors: any[] = err.violations;

            if (errors){
              errors.forEach((v) =>
              {
                if (v.propertyPath === 'type'){
                  this.menuForm.get('category')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'module'){
                  this.menuForm.get('module')?.setErrors({serverError: v.message});
                }
                console.log(v.message);
                if (v.propertyPath === 'name'){
                  this.menuForm.get('name')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'position'){
                  this.menuForm.get('position')?.setErrors({serverError: v.message});
                }

                this.saving = false;

              });
            }
            else {
              this.saving = false;
              this.toastr.error(err['hydra:title'], 'Error');
            }

          }
        });

    }
  }

  findAllModule(): any{
    this.moduleService.getEnableCollection().subscribe((data: any) => {
          this.modules = data['hydra:member'];
          this.modules = this.modules.map((v) => {
            v.id = v['@id'];
            console.log(v['@id']);
            return v;
          });
        },
        error => console.log(error)
    );
  }

  findAllPermissions(): any{
    this.permissionService.getEnableCollection().subscribe((data: any) => {
          this.permissions = data['hydra:member'];
          this.permissions = this.permissions.map((v) => {
            v.id = v['id'];
            console.log(v['@id']);
            return v;
          });
        },
        error => console.log(error)
    );
  }


}
